import { environment } from 'config/environment';

export const getEnv = (key: string): string => {
  return environment[key];
};
